import styled from "styled-components";

export const PreCadastroWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BtnGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    display: flex;
    height: fit-content;

    a {
      text-decoration: underline;
      font-weight: bold;
      padding: 3px 8px;
      border-radius: 5px;
      transition: 0.4s;

      &:hover {
        background-color: #24242410;
      }
    }
  }
`;

export const PreCadastroForm = styled.form`
  background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
  border: 1px solid ${({ theme }) => theme.colors.secundaria};
  border-radius: 4px;
  padding: 25px 20px;
  width: 650px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  @media only screen and (max-width: 800px) {
    width: 100%;
  }
`;

export const DivisoriaSecao = styled.section`
  border-top: 1px solid #0004;
  width: 100%;
  padding-top: 10px;
`;

export const TituloSecao = styled.h3`
  font-size: 18px;
  font-weight: bold;
`;
